export default __webpack_public_path__ + "442394e1859707c9c7be33f89018df2d.svg";